import { ApolloLink, FetchResult, Observable, Operation } from '@apollo/client';
import { print } from 'graphql';
import { createClient } from 'graphql-ws';

class WebSocketLink extends ApolloLink {
  [x: string]: any;
  constructor(options: any) {
    super();
    this.client = createClient(options);
  }

  request(operation: Operation): Observable<FetchResult> | null {
    return new Observable((sink) => {
      return this.client.subscribe(
        { ...operation, query: print(operation.query) },
        {
          next: sink.next.bind(sink),
          complete: sink.complete.bind(sink),
          error: (err: { code: any; reason: any; map: (arg0: ({ message }: { message: any }) => any) => any[] }) => {
            if (err instanceof Error) {
              return sink.error(err);
            }

            if (err instanceof CloseEvent) {
              return sink.error(
                // reason will be available on clean closes
                new Error(`Socket closed with event ${err.code} ${err.reason || ''}`),
              );
            }

            return sink.error(new Error(err.map(({ message }) => message).join(', ')));
          },
        },
      );
    });
  }
}

export default WebSocketLink;
